/*
 * @Descripttion:
 * @Author: chenmeng
 * @Date: 2020-03-05 01:26:37
 * @LastEditors: chenmeng
 * @LastEditTime: 2020-03-05 01:29:06
 */
import { http, https } from '../../global/axios';
import { SERVER_HOST } from '../../global/constants';
// 获取用户信息
export const  queryCurrent = (tid, token) =>{
    let q = '';
    if(tid) {
        q += '&tid=' + tid;
    }
    if(token) {
        q += '&token=' + token;
    }
    if(q) {
        q = '?' + q.substr(1);
    }
    return http.post(`${SERVER_HOST}/v1/system/weixin/login/login.json${q}`);
}
// 获取团队信息
export const detail = () => {
    return http.post(`/v1/team/offline/info.json`);
};
// 登录用户是否有团队 返回值 id 团队id forum (状态 0关闭 1 开启）
export const teamForum = () => {
    return http.post(`/v1/team/offline/teamForum.json`);
};
// 获取团队成员信息
export const members = (params) => {
    return http.post(`/v1/team/offline/members.json`, params);
}
// 删除团队成员
export const deleteMember = (params) => {
    return http.post(`/v1/team/offline/delete.json`, params);
}
//更改团队角色
export const updateRole = (params) => {
    return http.post(`/v1/team/offline/updateRole.json`, params);
}
//更改团队成员备注
export const updateExplain = (params) => {
    return http.post(`/v1/team/offline/updateExplain.json`, params);
}
// 获取申请成员列表
export const applys = (params) => {
    return http.post(`/v1/team/offline/applys.json`, params);
}
// 处理申请
export const checkApplyUser = (params) => {
    return http.post(`/v1/team/offline/check.json`, params);
}
// 更新团队信息
export const joinUpdate = (params) => {
    return https.post(`/v1/team/offline/info/update.json`, params);
}

export const withdraw = (params) => {
    return http.post(`/v1/team/offline/apply/withdraw.json`, params);
}
// 退出团队
export const quitTeam = (params) => {
    return http.post(`/v1/team/offline/quit.json`, params);
}

export const updateForum = (params) => {
    return http.post(`/v1/team/offline/updateForum.json`, params);
}

// 获取考核记录
export const getRecord = (parames) => {
    return http.post(`/v1/tags/study/logs.json`, parames);
};

// 获取团队成员记录
export const teamLogs = (params) => {
    return http.post(`/v2/tags/task/user/statistics.json`, params);
};

// 获取团队长记录
export  const teamLeaderLogs = (params) =>  {
    return http.post(`/v2/tags/task/team/statistics.json`, params);
};
// 获取审查统计数据
export const teamCheck = (params) =>  {
    return http.post(`/v1/team/offline/leader/tags/total/check.json`, params);
};

// 保底计划列表
export const planList = (params) =>  {
    return http.post(`/v2/tags/guarantee/team/history_record.json`, params);
};

// 获取审查授权列表
export const inspectors = (params) => {
    return http.post(`/v1/team/offline/leader/tags/inspectors.json`, params);
}

// 新增审查员
export const saveInspector = (params) => {
    return http.post(`/v1/team/offline/leader/tags/inspector/save.json`, params);
}

//删除审查员
export const deleteInspector = (params) => {
    return http.post(`/v1/team/offline/leader/tags/inspector/delete.json`, params);
}

//删除审查员
export const statisticsList = (params) => {
    return http.post(`/v1/team/offline/statistics/list.json`, params);
}
//根据公会ID查询公会
export const getTeamDetail = (params) => {
    return http.post(`/v1/team/offline/getTeamDetail.json`, params);
}

//申请加入公会
export const joinTeam = (params) => {
    return https.post(`/v1/team/offline/join.json`, params);
}

//获取小队列表
export const  groupList = () => {
    return https.post(`/v1/team/group/list.json`);
}
//新增小队
export const createGroup = (params) => {
    return https.post(`/v1/team/group/create.json`, params);
}
//修改小队
export const  updateGroup = (params) => {
    return https.post(`/v1/team/group/update.json`, params);
}
//删除小队
export const  deleteGroup = (params) => {
    return https.post(`/v1/team/group/delete.json`, params);
}
//更改小队
export const  changeGroup = (params) => {
    return https.post(`/v1/team/group/member/update.json`, params);
}

export const exportMembers = (data) => {
    return http.post(`v1/team/offline/members/export.json`, data, {responseType: 'blob'})
} 
export const exportStatistics = (data) => {
    return http.post(`v1/team/offline/statistics/members/export.json`,data,{responseType: 'blob'});
};